/**
 * Invoice hours source type DTO enum - matches backend API contract
 * Represents the type of hours source for invoice calculations
 */
export enum InvoiceHoursSourceTypeDTO {
  TRACKED_BILLABLE = 'TRACKED_BILLABLE',
  TRACKED_TOTAL = 'TRACKED_TOTAL',
  BOOKED_BILLABLE = 'BOOKED_BILLABLE',
  BOOKED_TOTAL = 'BOOKED_TOTAL',
  CAPACITY = 'CAPACITY',
  APPROVED_BILLABLE = 'APPROVED_BILLABLE',
  APPROVED_TOTAL = 'APPROVED_TOTAL',
  TIME_OFF = 'TIME_OFF',
}

/**
 * Type aliases for clear intent in request/response interfaces
 */
export type InvoiceHoursSourceTypeRequest = InvoiceHoursSourceTypeDTO;
export type InvoiceHoursSourceTypeResponse = InvoiceHoursSourceTypeDTO;
